<script setup lang="ts">
defineProps<{
  episode: PodcastRssEpisode | undefined
}>()
</script>

<template>
  <div v-if="episode?.image" class="rounded-lg size-[5.5rem] min-w-[5.5rem] lg:size-44 lg:min-w-44">
    <img :src="episode.image" alt="" class="object-cover rounded-lg">
  </div>
</template>
